import { Box, Typography, Button } from '@mui/material'
import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import CustomAppBar from '../components/CustomAppBar';
import Navbar from '../components/Navbar';
import AppContainer from '../components/AppContainer';
import TextContainer from '../components/TextContainer';
import SectionBanner from '../components/SectionBanner';
import { useSelector, useDispatch } from 'react-redux';
import AttributeContainer from '../components/AttributeContainer';
import LogoutIcon from '@mui/icons-material/Logout';
// Firebase
import { getAuth, signOut } from "firebase/auth";
// Redux
import { clearUser, setError, setLoading, setUserLoaded } from '../redux/userSlice';
import { clearSubscribedTopics } from '../redux/mqttSlice';
import { clearReduxHearts } from '../redux/heartSlice';
import { clearReduxGroups } from '../redux/groupSlice';
import SectionBanner2 from '../components/SectionBanner2';
import SettingsIcon from '@mui/icons-material/Settings';


function MyAccount() {
    const navigate = useNavigate();
    const params = useParams();
    const dispatch = useDispatch();
    const [namePopupOpen, setNamePopupOpen] = React.useState(false);

    const user = useSelector((state) => state.user.user);

    const handleSignOut = async () => {
        const auth = getAuth();
        try {
            await signOut(auth);
            // Clear user from Redux store
            try {
                // TODO: move to clearUserReduxData thunk
                dispatch(setLoading(true));
                dispatch(clearUser());
                dispatch(setUserLoaded(false));

                dispatch(clearReduxHearts());   // clear redux hearts and grouphearts
                dispatch(clearReduxGroups());   // clear redux groups
                dispatch(clearSubscribedTopics());  // mqtt topics
                dispatch(setLoading(false));
                console.log('User signed out successfully.');
            } catch (error) {
                dispatch(setError(error.message));
                dispatch(setLoading(false));
            }
        } catch (error) {
          console.error('Error signing out:', error.message);
        }
      };

    return (
        <AppContainer>
            <CustomAppBar />
            <Navbar title={"My Account"} backButton />
            <SectionBanner2 text={"Account Settings"} IconComponent={SettingsIcon} customStyles={{marginTop: '15px'}}/>
            <TextContainer>
                <AttributeContainer attribute={"Username:"} value={user.username} />
                <AttributeContainer attribute={"Email:"} value={user.email} />
                {/* Sign-out Button */}
                <Button
                    variant="contained"
                    color="primary"
                    startIcon={<LogoutIcon />}
                    sx={{ marginTop: "30px", width: '100%' }}
                    onClick={handleSignOut}
                >
                    Sign Out
                </Button>
            </TextContainer>
        </AppContainer>
    )
}

export default MyAccount